import { combineReducers } from 'redux';

import { allLoadedReducer } from './allLoadedReducer';
import { modalsReducer } from './modalReducer';
import { oneLoadedReducer } from './oneLoadedReducer';
import { sessionReducer } from './sessionReducer';

export const appStatusReducer = combineReducers({
  allLoaded: allLoadedReducer,
  modals: modalsReducer,
  oneLoaded: oneLoadedReducer,
  session: sessionReducer,
});
